<div class="slider-container">
  @if (!isMatSlider) {
    <div>
      <input
        type="range"
        class="slider"
        [(ngModel)]="sliderValue"
        (ngModelChange)="valueChange?.emit($event)"
        [min]="min"
        [max]="max"
        [step]="step" />
      {{ showValue ? sliderValue : "" }}
    </div>
  }
  @if (isMatSlider) {
    <div>
      <mat-slider
        class="material-slider"
        [max]="max"
        [min]="min"
        [step]="step"
        [discrete]="true"
        [disableRipple]="true"
        [showTickMarks]="true"
        #ngSlider>
        <input
          matSliderThumb
          [(ngModel)]="model"
          (input)="sliderValueChange({ source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value })"
          #ngSliderThumb="matSliderThumb" />
      </mat-slider>
    </div>
  }
</div>
